import {BaseAreaViewAsync, OBaseAreaViewInit} from "lib/commons/views";
import {IReg, IRegPointer, REG} from "lib/commons/registry";
import {IWspUiEnv, JWspTypeInst, WSPMETA} from "lib/wsp/wsp";
import {DOMSH} from "lib/commons/xml/domsh";
import {Tabs} from "back/commons/widgets/tabs";
import {DOM, JSX} from "lib/commons/xml/dom";
import {IO} from "lib/commons/io/io";
import {IChainEnv} from "lib/wsp/chain";
import {Grid, OGridSmallInit} from "back/commons/widgets/grid-tags";
import {ESrcField, JSrcFields, SRC, srcId, srcUri} from "lib/wsp/src";
import {WspMetaUi} from "lib/wsp/wspMetaUi";
import {GridColDef} from "back/commons/widgets/grid-core";
import {CellBuilderSrcIconCode} from "back/wsp/widgets/srcGridColumns";
import {CellBuilderString, GridDataHolderJsonArray, GridDataRowJson} from "back/commons/widgets/grid-libs";
import {Action} from "lib/commons/actions";
import {AppFrameDeskFeat} from "back/core/appFrame";
import {JTaskAppDef} from "back/wsp/plugins/tasksPlg";
import {ITEM} from "lib/wsp/item";
import {POPUP} from "back/commons/widgets/popups";
import {EInvolvement, TASK} from "lib/wsp/lcTask";


/**
 * Liste des tâches du user trans-ateliers (au niveau Repository).
 */
export interface MyTasksRepos extends BaseAreaViewAsync<IRegPointer<IWspUiEnv>> {
	initialize(init: OMyTasksReposInit): this
}

export interface OMyTasksReposInit extends OBaseAreaViewInit<IRegPointer<IWspUiEnv>> {
}

export class MyTasksRepos extends BaseAreaViewAsync<IRegPointer<IWspUiEnv>> {
	reg: IReg<IChainEnv | IWspUiEnv>;
	/** Map des définitions d'ateliers */
	wspMap: Map<string, {
		wspCd: string
		title: string
		wspMeta: JWspTypeInst
		wspMetaUi?: WspMetaUi //ajouté localement
	}>; //MyTasks inter-wsp (IChainEnv)
	tabs: Tabs;
	pendingTodo: Grid;
	pendingTofollow: Grid;
	forthcoming: Grid;
	tkClosed: Grid;

	fetchState: 'done' | 'failed';

	protected async _initialize(init: OMyTasksReposInit): Promise<void> {
		super._initialize(init); //init this.reg, this.area, this.areaContext
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		const emptyBody = () => {
			switch (this.fetchState) {
			case "done":
				return <c-msg>Aucune tâche</c-msg>;
			case "failed":
				return <c-msg level="error">Échec au chargement</c-msg>;
			default:
				return <c-msg>Chargement en cours...</c-msg>;
			}
		};

		this.tabs = <Tabs id="tabs" skin-over="wsp-mytasks/tabs"/> as Tabs;
		const columnDefs = [new GridColDef('srcCode').setLabel("Libellé")
			.setDefaultSort(1, 'ascendant')
			.setFlex('25em', 1, 1).setMinWidth('8em').setSortable(true)
			.setCellBuilder(new CellBuilderReposTk(this.reg)),
			new GridColDef('wspTi').setLabel("Atelier")
				.setFlex('10em', 1, 1).setMinWidth('8em').setSortable(true)
				.setCellBuilder(new CellBuilderString('wspTi'))
		];
		this.pendingTodo = this.tabs.appendChild(<Grid code="pendingTodo" label="À faire" î={{
			reg: this.reg,
			columnDefs,
			dataHolder: new GridDataHolderJsonArray<ITaskReposData>(),
			defaultAction: OpenTaskApp.SINGELTON,
			selType: "monoOver",
			skinScroll: 'scroll/small',
			emptyBody
		} as OGridSmallInit}/>) as Grid;
		this.pendingTofollow = this.tabs.appendChild(<Grid code="pendingTofollow" label="À suivre" î={{
			reg: this.reg,
			columnDefs,
			dataHolder: new GridDataHolderJsonArray<ITaskReposData>(),
			defaultAction: OpenTaskApp.SINGELTON,
			selType: "monoOver",
			skinScroll: 'scroll/small',
			emptyBody
		} as OGridSmallInit}/>) as Grid;
		// this.forthcoming = this.tabs.appendChild(<SrcGrid code="forthcoming" label="À venir" î={{
		// 	reg: this.reg,
		// } as OSrcGridConfigs}/>) as Grid;
		// this.tkClosed = this.tabs.appendChild(<SrcGrid code="tkClosed" label="Fermées" î={{
		// 	reg: this.reg,
		// } as OSrcGridConfigs}/>) as Grid;

		sr.appendChild(this.tabs);

		return this.fetchPendings();
	}

	async fetchPendings() {
		try {
			const datas = await this.reg.env.universe.wspServer.config.tasksUrl.fetchJson<JMyTasksRepos>(IO.qs("cdaction", "GetMyTasksAtRepos", "fields", reposTaskFields));

			//console.log("fetchTasks:::::::::", datas);
			this.wspMap = new Map();
			const wspMeatsCache = new WSPMETA.WspMetasCache(this.reg.env.universe.wspServer);
			for (const w of datas.wsps) wspMeatsCache.fetchWspMetaUi(w.wspMeta = wspMeatsCache.atomWspTypeInst(w.wspMeta));
			await wspMeatsCache.waitForAll();
			for (const w of datas.wsps) {
				w.wspMetaUi = wspMeatsCache.getWspMetaUi(w.wspMeta);
				this.wspMap.set(w.wspCd, w);
			}
			const toDoTk: ITaskReposData[] = [];
			const toFollowTk: ITaskReposData[] = [];
			const userFlatGroups: string[] = await this.reg.env.universe.auth.fetchFlattenedGroups();
			for (const w of datas.tasks) {
				const wspCd = extractWspCdFromReposUri(w.srcUri);
				const wspInfo = this.wspMap.get(wspCd);
				if (wspInfo) {
					const taskData: ITaskReposData = {
						srcUri: extractSrcUriFromReposUri(w.srcUri),
						actTi: w.actTi,
						itModel: extractTaskModelFromReposUri(w.srcUri),
						wspMetaUi: wspInfo.wspMetaUi,
						wspTi: wspInfo.title,
						wspCd: wspCd,
						tkDeadline: w.tkDeadline
					};
					w.itModel = extractTaskModelFromReposUri(w.srcUri);
					const inv = TASK.getInvolvementForAccounts(userFlatGroups, w, wspInfo.wspMetaUi);
					if ((inv & EInvolvement.executor) != 0) {
						toDoTk.push(taskData);
					}
					if ((inv & EInvolvement.follower) != 0) {
						toFollowTk.push(taskData);
					}
				} else {
					// wsp lié à la tache non chargé => tache ignorée
				}
			}
			//console.log("toDoTk:::::::::::::", toDoTk);
			this.fetchState = "done"; //Avant le setData pour l'eval du empty.
			(this.pendingTodo.dataHolder as GridDataHolderJsonArray<ITaskReposData>).setDatas(toDoTk);
			(this.pendingTofollow.dataHolder as GridDataHolderJsonArray<ITaskReposData>).setDatas(toFollowTk);
		} catch (e) {
			this.fetchState = "failed";
			(this.pendingTodo.dataHolder as GridDataHolderJsonArray<ITaskReposData>).setDatas([]);
			(this.pendingTofollow.dataHolder as GridDataHolderJsonArray<ITaskReposData>).setDatas([]);
			throw e;
		}
	}
}

REG.reg.registerSkin("wsp-mytasks-repos", 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		width: 35em;
	}

	#tabs {
		flex: 1;
	}

	c-grid {
		border: none;
	}
`);

//REG.reg.registerSkin("wsp-mytasks/tabs", 1, /* language=CSS */ ``);

customElements.define("wsp-mytasks-repos", MyTasksRepos);


/** Fields disponibles hors atelier (au niveau du repos). */
const reposTaskFields = (["srcUri", "actTi", "tkDeadline", "rspUsrs", "lcSt"] as ESrcField[]).join('*');

/** Donnée retourné par le fetch dans les grid dans le contexte du Repos. */
interface JMyTasksRepos {
	tasks: JSrcFields[]
	wsps: {
		wspCd: string
		title: string
		wspMeta: JWspTypeInst
		wspMetaUi?: WspMetaUi //ajouté localement
	}[]
}

/** Struct de donnée des tasks dans les grid dans le contexte du Repos.  */
interface ITaskReposData {
	srcUri: string
	itModel: string
	wspTi: string
	wspCd: string
	wspMetaUi: WspMetaUi
	actTi: string
	tkDeadline: number
}

class CellBuilderReposTk extends CellBuilderSrcIconCode {

	constructor(reg: IReg<any>) {
		super(reg, null, true, SRC.sortSrcUriTree);
	}

	protected _getValue(row: GridDataRowJson<ITaskReposData>): string {
		return row.cacheHolder['code'] || (row.cacheHolder['code'] = this.srcRdr.getMainName(row.rowDatas, row.rowDatas.wspMetaUi));
	}

	protected _getIcon(row: GridDataRowJson<ITaskReposData>): string {
		return row.cacheHolder['icon'] || (row.cacheHolder['icon'] = this.srcRdr.getIcon(row.rowDatas, row.rowDatas.wspMetaUi));
	}

	protected _getDescription(row: GridDataRowJson<ITaskReposData>): any {
		return this.srcRdr.getSecondName(row.rowDatas, row.rowDatas.wspMetaUi);
	}
}

class OpenTaskApp extends Action<Grid> {
	static SINGELTON = new OpenTaskApp();

	execute(ctx: Grid, ev?: Event): any | "noPreventDefault" {
		const row = ctx.getSelectedRow();
		if (row >= 0) {
			const rowDatas = ctx.dataHolder.getRow(row).rowKey as ITaskReposData;
			(desk as AppFrameDeskFeat).findAndOpenApp({task: extractTaskIdFromSrcUri(rowDatas.srcUri), w: rowDatas.wspCd} as JTaskAppDef, ev);
			POPUP.findPopupableParent(ctx).close();
		}
	}
}

function extractWspCdFromReposUri(reposUri: string) {
	return reposUri.substring(1, reposUri.indexOf('/', 1));
}

function extractSrcUriFromReposUri(reposUri: string) {
	return reposUri.substring(reposUri.indexOf('/', 1));
}

function extractTaskModelFromReposUri(reposUri: string) {
	return "stk_" + reposUri.substring(reposUri.lastIndexOf('/') + 1, reposUri.lastIndexOf('.'));
}

function extractTaskIdFromSrcUri(srcUri: srcUri): srcId {
	if (!srcUri || !srcUri.startsWith(ITEM.ANNOT_PREFIX)) return null;
	return SRC.ID_PREFIX + srcUri.substring(ITEM.ANNOT_PREFIX.length, srcUri.indexOf('/', ITEM.ANNOT_PREFIX.length + 1));
}
